import { Validator, errorMessages, constants } from 'src/services/validator'
import {
  NEW_PASSWORD_PROPERTY,
  NEW_PASSWORD_CONFIRMATION_PROPERTY
} from './constants'

export const rules = [
  {
    label: errorMessages.PASSWORD_LENGTH,
    checkValidity: Validator.createFieldValidator({
      fieldName: NEW_PASSWORD_PROPERTY,
      validators: [Validator.required(), Validator.length(constants.PASSWORD_MIN_LENGTH)]
    })
  },
  {
    label: errorMessages.PASSWORD_LETTER,
    checkValidity: Validator.createFieldValidator({
      fieldName: NEW_PASSWORD_PROPERTY,
      validators: [Validator.required(), Validator.containUpperLowerCaseLetter()]
    })
  },
  {
    label: errorMessages.PASSWORD_NUMBER,
    checkValidity: Validator.createFieldValidator({
      fieldName: NEW_PASSWORD_PROPERTY,
      validators: [Validator.required(), Validator.containNumber()]
    })
  },
  {
    label: errorMessages.PASSWORD_SPECIAL_CHARACTER,
    checkValidity: Validator.createFieldValidator({
      fieldName: NEW_PASSWORD_PROPERTY,
      validators: [Validator.required(), Validator.containSpecialCharacter()]
    })
  },
  {
    label: errorMessages.PASSWORD_MATCH,
    checkValidity: Validator.createFieldValidator({
      fieldName: NEW_PASSWORD_PROPERTY,
      validators: [Validator.required(), Validator.match(NEW_PASSWORD_CONFIRMATION_PROPERTY)]
    })
  }
]

